import { AppContext } from "01Data/AppData";
import { LogIDSection } from "97Parts/Andon/LogSection";
import { useModel } from "99Tools/useModel";
import { useContext } from "react";

/**
 * ログ一覧表示
 * @returns TSX
 */
const LogIDPage = () => {
  const a = useContext(AppContext).dataUser;
  useModel(a.andon.log);
  return <LogIDSection log={a.andon.log} devices={a.andon.devices} />;
};
export default LogIDPage;
